export class UserGroup {
  constructor(
    public id: string,
    public customerId: string,
    public activityId: string,
    public name: string,
    public users: string[]
  ) {}
}
